import { BaseClient } from '../client';
import { TConcessionariaRevendaVincularDTO } from './concessionariaRevenda.types';

interface ApiResponse<T> {
	success: boolean;
	message: string;
	data: T;
}

export const postVincular = async (dto: TConcessionariaRevendaVincularDTO) => {
	try {
		const response = await BaseClient.post<ApiResponse<string>>(
			`v2/ConcessionariaRevenda/Vincular`,
			dto
		);

		return response.data.message;
	} catch (error) {
		console.error(error);
		throw error;
	}
};
